import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { take } from 'rxjs/operators';
import { OnsiteSingleTimeline } from 'globals/store/onsite.data';
import { LabelMaps, Ranking, Venue } from 'globals/store/events.data';
import { ShareOSSInfo } from 'globals/store/share.data';
import { Performer } from 'globals/store/performers.data';
import { FullSharedFilteredOSSTimelineAndShareableAndPerformersData } from 'globals/share/onsite.reselector.functions';
import { Sponsor } from 'globals/store/sponsors.data';
import { TagPanelData } from 'globals/store/tags.data';
import { BrandingData } from 'globals/store/publish.data';
import { Dictionary } from '@ngrx/entity';
import { environment } from '../../../environments/environment';
import { OnsiteShareTimelineComponent } from '../onsiteschedule/onsite.share.timeline.component';

@Component({
    selector: 'share-oss-page',
    template: `
<share-timeline 
  [timeline]="timeline" 
  [eventId]="ossShareInfo?.eventId"
  [shareId]="id"
  [performers]="performers" 
  [sponsors]="sponsors"
  [sponsorTypes]="sponsorTypes"
  [venues]="venues"
  [labelMaps]="labelMaps"
  [ossShareInfo]="ossShareInfo"
  [loading]="loading"
  [madeWithJoi]="madeWithJoi"
  [unavailable]="unavailable"
  [performerRoles]="performerRoles"
  [showActivityStatus]="showActivityStatus"
  [publicView]="true"
  [tagMap]="tagMap"
  [brandingData]="brandingData"
></share-timeline>
    `,
    standalone: true,
    imports: [OnsiteShareTimelineComponent]
})
export class ShareOSSPageComponent {

    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
    id:string;
    timeline: OnsiteSingleTimeline[]
    performers: { [pId: string]: Performer }
    sponsors: { [pId: string]: Sponsor }
    sponsorTypes: { [tId:string]: Ranking }
    labelMaps: LabelMaps
    ossShareInfo: ShareOSSInfo
    madeWithJoi = true
    showActivityStatus = false
    loading = true;
    unavailable = false;
    venues: { [vId: string]: Venue }
    tagMap: { [vId:string]: TagPanelData } = {}
    brandingData: BrandingData
    performerRoles: Dictionary<Ranking>

    constructor( 
      private route:ActivatedRoute, 
      private http:HttpClient 
    ) {
      // console.log('subscribing...')
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('id')) {
          this.loading = false;
          document.title = "Timeline unavailable";
        } else {
          this.id = params.id;
          this.sharedDownloadOSSTimeline(params.id)
        }
        document.title = "loading";
      })
    }

    sharedDownloadOSSTimeline(id){
      const url = `${this.api}/load-share-oss-data`
      this.http.post(url, { id }).pipe(take(1)).subscribe((data: FullSharedFilteredOSSTimelineAndShareableAndPerformersData) => {
        console.log({ data});
        const { info, timeline, performers, labelMaps, showActivityStatus, hideJoi, sponsors, sponsorTypes, venues, tagMap, brandingData, performerRoles } = data
        this.madeWithJoi = !hideJoi
        this.ossShareInfo = info
        this.timeline = timeline
        this.performers = performers
        this.sponsors = sponsors
        this.sponsorTypes = sponsorTypes
        this.labelMaps = labelMaps
        this.loading = false
        this.venues = venues
        this.showActivityStatus = showActivityStatus
        this.tagMap = tagMap
        this.brandingData = brandingData
        this.performerRoles = performerRoles
        const { eventTitle, title, description } = info
        document.title = eventTitle || title || description || 'Untitled Onsite Timeline from Joi'
        // this.loading = false;
      }, (response) => {
        this.loading = false;
        this.unavailable = true;
        // console.log({ response })
        document.title = "Timeline unavailable";
      });
    }

}

